/**
 * Utils for polling
 * @module
 */
var _ = require('optimizely-client-fn');

var PromiseEnv = require('../lib/promise').Promise;
var WindowEnv = require('../env/window');

var MAX_RETRIES = __TEST__ ? 5 : 100;
var DEFAULT_INTERVAL = 50;

/**
 * Poll for a truthy result from pollFn, waiting interval between tries and with maximum maxRetries attempts.
 *
 * @param {Function(): *} pollFn - function with no arguments
 * @param {number} [interval]
 * @param {(number|function)} [endPoll] either a number of max retries or a function to determine isTimedOut.
 * If not a function and falsy, it will use MAX_RETRIES
 * @returns {Promise}
 */
exports.pollFor = function(pollFn:Function, interval?:number, endPoll?:number|Function): Promise<any> {
  var retriesRemaining;
  var isTimedOut;

  if (_.isFunction(endPoll)) {
    isTimedOut = endPoll;
  } else {
    retriesRemaining = endPoll || MAX_RETRIES;
    isTimedOut = function() {
      retriesRemaining--;
      // The endPoll argument represents max retries: total tries = endPoll + 1
      return retriesRemaining < -1;
    };
  }
  interval = interval || DEFAULT_INTERVAL;

  return new PromiseEnv(function(resolve, reject) {
    (function poll() {
      var lastError;

      if (!isTimedOut()) {
        try {
          var result = pollFn();
          if (result) {
            return resolve(result);
          }
        } catch(e) {
          lastError = e;
        }

        return WindowEnv.setTimeout(poll, interval);
      }
      reject(lastError || new Error('Poll timed out'));
    }());
  });
};
